import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class PseService {
  PseBank = environment.urlglobal_api + '/api/v3/checkout/pse/banks';
  PseTicket = environment.urlglobal_api + '/api/v3/checkout/pse/ticket';
  PseUrlReturn = environment.urlglobal + '/api/v2/psetransactions/token/url';
  PseConsulta = environment.urlglobal_api + '/api/v3/checkout/pse/ticket';


  constructor(public http: HttpClient) {}
    public getUrlReturn(parameters) {
    const json = JSON.stringify(parameters);
    return this.http.post(this.PseUrlReturn, json);
  }


  public getListBancPost(parameters) {
    const json = JSON.stringify(parameters);
    return this.http.post(this.PseBank, json);
  }


  public PostTikect(parameters): Promise<any> {
    const json = JSON.stringify(parameters);
    return this.http.post(this.PseTicket, json).toPromise();
  }


  public Consultaavvillas(parameters) {
    const json = JSON.stringify(parameters);
    return this.http.post(this.PseConsulta, json);
  }


}
